import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Info, X, GripHorizontal, GripVertical } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * DashboardTutorial Component
 * Shows helpful tips for drag-and-drop and resizing
 */
const DashboardTutorial = () => {
  const { language } = useLanguage();
  const [isDismissed, setIsDismissed] = useState(() => {
    return localStorage.getItem('dashboard-tutorial-dismissed') === 'true';
  });

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem('dashboard-tutorial-dismissed', 'true');
  };

  if (isDismissed) return null;

  return (
    <div className="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 border border-purple-200 dark:border-purple-800 rounded-lg p-4 mb-4 mx-4 mt-4">
      <div className="flex items-start gap-3">
        <Info className="w-5 h-5 text-purple-600 dark:text-purple-400 flex-shrink-0 mt-0.5" />
        
        <div className="flex-1 space-y-2">
          <h3 className="font-semibold text-purple-900 dark:text-purple-100 flex items-center gap-2">
            {language === 'es' ? '🎨 Nuevo: Diseño Personalizable' : '🎨 New: Customizable Layout'}
          </h3>
          
          <div className="space-y-1 text-sm text-purple-800 dark:text-purple-200">
            <p className="flex items-center gap-2">
              <GripHorizontal className="w-4 h-4" />
              <strong>{language === 'es' ? 'Reordenar:' : 'Reorder:'}</strong>
              {language === 'es' 
                ? 'Arrastra el encabezado del panel para reordenar'
                : 'Drag the pane header to reorder'}
            </p>
            <p className="flex items-center gap-2">
              <GripVertical className="w-4 h-4" />
              <strong>{language === 'es' ? 'Redimensionar:' : 'Resize:'}</strong>
              {language === 'es'
                ? 'Arrastra el borde derecho para ajustar el ancho'
                : 'Drag the right edge to adjust width'}
            </p>
            <p className="flex items-center gap-2">
              <X className="w-4 h-4" />
              <strong>{language === 'es' ? 'Eliminar:' : 'Remove:'}</strong>
              {language === 'es'
                ? 'Pasa el cursor sobre el panel y haz clic en ✕'
                : 'Hover over pane and click ✕'}
            </p>
          </div>
        </div>

        <Button
          variant="ghost"
          size="sm"
          onClick={handleDismiss}
          className="h-6 w-6 p-0 hover:bg-purple-200 dark:hover:bg-purple-800"
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};

export default DashboardTutorial;
